function r(r,o){if(void 0!==r.order&&void 0===o.order)return-1;if(void 0===r.order&&void 0!==o.order)return 1;if(void 0!==r.order&&void 0!==o.order){if(r.order>o.order)return 1;if(r.order<o.order)return-1}return 0}export{r as compareParameterGroups};
//# sourceMappingURL=Parameters.utils.js.map
